import { render, staticRenderFns } from "./TDark.vue?vue&type=template&id=076b817c&scoped=true&"
import script from "./TDark.vue?vue&type=script&lang=js&"
export * from "./TDark.vue?vue&type=script&lang=js&"
import style0 from "./TDark.vue?vue&type=style&index=0&id=076b817c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076b817c",
  null
  
)

export default component.exports